import { createContext, useContext } from 'react';
import { useSnackbar } from 'notistack';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const notification = {
    success: (message, options = {}) => {
      enqueueSnackbar(message, {
        variant: 'success',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        ...options,
      });
    },
    error: (message, options = {}) => {
      enqueueSnackbar(message, {
        variant: 'error',
        autoHideDuration: 4000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        ...options,
      });
    },
    warning: (message, options = {}) => {
      enqueueSnackbar(message, {
        variant: 'warning',
        autoHideDuration: 3500,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        ...options,
      });
    },
    info: (message, options = {}) => {
      enqueueSnackbar(message, {
        variant: 'info',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        ...options,
      });
    },
    close: (key) => {
      closeSnackbar(key);
    },
  };

  return (
    <NotificationContext.Provider value={notification}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
